module.exports = __webpack_public_path__ + "static/img/logo_20230718.99acf206.svg";